import { getDeclineExistingCalendarEventsEnabled } from '../selectors/getStoreProperties';
/**
 * Utility function to get decline event for scheduled state status
 * @returns decline event is enabled or disabled status of type boolean
 */
export default function getDeclineEventsForScheduled() {
    return getDeclineExistingCalendarEventsEnabled();
}
//# sourceMappingURL=getDeclineEventsForScheduled.js.map